import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { JournalEntryLine, JournalEntryLineCreate, JournalEntryLineFilter } from '../data/journalEntryLine';

export function createJournalEntryLineService(client: AxiosInstance) {
  return createCrudService<JournalEntryLine, JournalEntryLineCreate, JournalEntryLineFilter>(
    client,
    '/accounting/JournalEntryLine',
    'id',
  );
}

export type JournalEntryLineService = CrudService<JournalEntryLine, JournalEntryLineCreate, JournalEntryLineFilter>;
